import { isEqual } from 'lodash';
import { AIRPORTS_FIELD_RESET_CLICKED, AIRPORTS_FIELD_SUGGESTIONS_NO_MATCH, AIRPORTS_FIELD_VALUE_CHANGED, DESTINATION_FIELD_RESET_CLICKED, DESTINATION_FIELD_VALUE_CHANGED, FORM_SUBMITTED, RECENT_SEARCH_TRIGGERED, TRAVEL_PERIOD_FIELD_VALUE_CHANGED, TRAVELLERS_FIELD_MULTIROOM_RESET_CLICKED, TRAVELLERS_FIELD_MULTIROOM_VALUE_CHANGED, TRAVELLERS_FIELD_RESET_CLICKED, TRAVELLERS_FIELD_VALUE_CHANGED } from '../../../components/SearchForm/redux/actions.js';
import { mapBooleanToEvent, mapTravelType } from '../../../components/SearchForm/redux/utils.js';
const trackDestinationFieldValueChanged = action => {
  return {
    event: 'search',
    event_action: 'search_enter_travel_destination',
    search_form: mapTravelType(action.meta.travelType),
    term: action.payload.value.keyword,
    search_destination_id: action.payload.value.id,
    search_top_destination: mapBooleanToEvent(action.meta.isTopDestination),
    non_interaction: false
  };
};
const recentSearchTriggered = () => {
  return {
    event: 'search',
    event_action: 'search_recent_item_trigger',
    search_last_item_selected: '1',
    search_last_item_shown: '1',
    non_interaction: false
  };
};
const trackDestinationFieldReset = action => {
  return {
    event: 'search',
    event_action: 'search_back_travel_destination',
    search_form: mapTravelType(action.meta.travelType),
    // term: action.payload.value.keyword,
    // search_destination_id: action.payload.value.id,
    // search_top_destination: mapBooleanToEvent(action.meta.isTopDestination),
    non_interaction: false
  };
};
const mapSuggestionsInputValueToEvent = suggestionInputValue => {
  if (suggestionInputValue === '') {
    return {};
  }
  return {
    search_airport_input: suggestionInputValue
  };
};
const trackAirportsFieldValueChanged = action => {
  return {
    event: 'search',
    event_action: 'search_enter_departure_airport',
    search_form: mapTravelType(action.meta.travelType),
    search_departure_codes: action.payload.value.join(','),
    search_airport_nearby: mapBooleanToEvent(action.payload.isNearbySelected),
    ...mapSuggestionsInputValueToEvent(action.payload.suggestionInputValue),
    non_interaction: false
  };
};
const trackAirportsFieldSuggestionNoMatch = action => {
  return {
    event: 'search',
    event_action: 'search_no_airport_found',
    ...mapSuggestionsInputValueToEvent(action.payload.suggestionInputValue),
    non_interaction: false
  };
};
const trackAirportsFieldResetClicked = action => {
  return {
    event: 'search',
    event_action: 'search_back_departure_airport',
    search_form: mapTravelType(action.meta.travelType),
    search_departure_codes: action.payload.value.join(','),
    non_interaction: false
  };
};
const trackTravellersFieldValueChanged = action => {
  return {
    event: 'search',
    event_action: 'search_enter_travelers',
    search_form: mapTravelType(action.meta.travelType),
    search_number_of_adults: String(action.payload.value.adultCount),
    search_number_of_children: String(action.payload.value.childrenAges.length),
    search_child_ages: action.payload.value.childrenAges.join(','),
    non_interaction: false
  };
};
const trackTravellersFieldMultiroomValueChanged = action => {
  return {
    event: 'search',
    event_action: 'search_enter_travelers_multiroom',
    search_form: mapTravelType(action.meta.travelType),
    search_number_of_adults: String(action.payload.value.adultsCount),
    search_number_of_children: String(action.payload.value.childrenCount),
    search_child_ages: action.payload.value.rooms.flatMap(room => room.childrenAges).join(','),
    search_number_of_rooms: String(action.payload.value.rooms.length),
    non_interaction: false
  };
};
const trackTravellersFieldResetClicked = action => {
  return {
    event: 'search',
    event_action: 'search_back_travelers',
    search_form: mapTravelType(action.meta.travelType),
    search_number_of_adults: String(action.payload.value.adultCount),
    search_number_of_children: String(action.payload.value.childrenAges.length),
    search_child_ages: action.payload.value.childrenAges.join(','),
    non_interaction: false
  };
};
const trackTravellersFieldMultiroomResetClicked = action => {
  return {
    event: 'search',
    event_action: 'search_back_travelers_multiroom',
    search_form: mapTravelType(action.meta.travelType),
    search_number_of_adults: String(action.payload.value.adultsCount),
    search_number_of_children: String(action.payload.value.childrenCount),
    search_child_ages: action.payload.value.rooms.flatMap(room => room.childrenAges).join(','),
    search_number_of_rooms: String(action.payload.value.rooms.length),
    non_interaction: false
  };
};
const trackTravelPeriodFieldValueChanged = action => {
  return {
    event: 'search',
    event_action: 'search_enter_travel_duration',
    search_form: mapTravelType(action.meta.travelType),
    search_startdate: action.payload.value.startDate,
    search_enddate: action.payload.value.endDate,
    search_duration_min: action.payload.value.duration?.min,
    search_duration_max: action.payload.value.duration?.max,
    search_duration_type: action.payload.context?.type,
    search_vacation: action.payload.context?.selectedState?.label,
    non_interaction: false
  };
};
const trackFormSubmitted = action => {
  if (action.payload.invalid) {
    // only a valid form being submitted should lead to a search being tracked (event fires regardless of invalid state)
    return;
  }
  const {
    travelType,
    values,
    prevValues,
    multiroomEnabled
  } = action.payload;
  if (prevValues !== undefined && isEqual(prevValues, values)) {
    // tracking should push to datalayer only if some field value is changed
    return;
  }
  const {
    defaultValues
  } = action.meta;
  const searchNumberOfAdults = multiroomEnabled ? values.travellersMultiroom?.adultsCount : values.travellers?.adultCount;
  const searchDefaultNumberAdults = multiroomEnabled ? defaultValues.travellersMultiroom?.adultsCount : defaultValues.travellers?.adultCount;
  const searchNumberOfChildren = multiroomEnabled ? values.travellersMultiroom?.childrenCount : values.travellers?.childrenAges.length;
  const searchDefaultNumberChildren = multiroomEnabled ? defaultValues.travellersMultiroom?.childrenCount : defaultValues.travellers?.childrenAges.length;
  const hasChildrenCount = values.travellersMultiroom?.childrenCount != null || (values.travellers?.childrenAges?.length ?? 0) > 0;
  const hasDefaultChildrenCount = defaultValues.travellersMultiroom?.childrenCount != null || (defaultValues.travellers?.childrenAges?.length ?? 0) > 0;
  const addDefaultSuffixIfNecessary = (value, defaultValue) => {
    if (defaultValue && defaultValue === value) {
      return `${value}_d`;
    }
    return value;
  };
  return {
    event: 'search',
    event_action: 'search_started',
    search_form: mapTravelType(travelType),
    search_startdate: addDefaultSuffixIfNecessary(values.travelPeriod?.startDate ?? '', defaultValues.travelPeriod?.startDate ?? ''),
    search_enddate: addDefaultSuffixIfNecessary(values.travelPeriod?.endDate ?? '', defaultValues.travelPeriod?.endDate ?? ''),
    search_duration_min: addDefaultSuffixIfNecessary(String(values.travelPeriod?.duration?.min ?? ''), String(defaultValues.travelPeriod?.duration?.min ?? '')),
    search_duration_max: addDefaultSuffixIfNecessary(String(values.travelPeriod?.duration?.max ?? ''), String(defaultValues.travelPeriod?.duration?.max ?? '')),
    search_duration_type: values.travelPeriod?.inputType,
    search_vacation: values.travelPeriod?.selectedState?.label,
    term: addDefaultSuffixIfNecessary(values.destination?.keyword ?? '', defaultValues.destination?.keyword ?? ''),
    search_destination_id: addDefaultSuffixIfNecessary(values.destination?.id ?? '', defaultValues.destination?.id ?? ''),
    search_departure_codes: addDefaultSuffixIfNecessary(Array.isArray(values.airports) ? values.airports.join(',') : '', Array.isArray(defaultValues.airports) ? defaultValues.airports.join(',') : ''),
    search_number_of_adults: addDefaultSuffixIfNecessary(String(searchNumberOfAdults ?? ''), String(searchDefaultNumberAdults ?? '')),
    search_number_of_children: addDefaultSuffixIfNecessary(hasChildrenCount ? String(searchNumberOfChildren) : '', hasDefaultChildrenCount ? String(searchDefaultNumberChildren) : ''),
    search_last_item_selected: mapBooleanToEvent(action.payload.clickLastSearches),
    search_last_item_shown: mapBooleanToEvent(action.payload.lastSearches),
    search_child_ages: addDefaultSuffixIfNecessary(values.travellers?.childrenAges != null ? values.travellers.childrenAges.join(',') : '', defaultValues.travellers?.childrenAges != null ? defaultValues.travellers.childrenAges.join(',') : ''),
    non_interaction: false
  };
};
export const trackingEvents = {
  [DESTINATION_FIELD_VALUE_CHANGED]: trackDestinationFieldValueChanged,
  [DESTINATION_FIELD_RESET_CLICKED]: trackDestinationFieldReset,
  [AIRPORTS_FIELD_VALUE_CHANGED]: trackAirportsFieldValueChanged,
  [AIRPORTS_FIELD_RESET_CLICKED]: trackAirportsFieldResetClicked,
  [AIRPORTS_FIELD_SUGGESTIONS_NO_MATCH]: trackAirportsFieldSuggestionNoMatch,
  [TRAVELLERS_FIELD_VALUE_CHANGED]: trackTravellersFieldValueChanged,
  [TRAVELLERS_FIELD_MULTIROOM_VALUE_CHANGED]: trackTravellersFieldMultiroomValueChanged,
  [TRAVELLERS_FIELD_RESET_CLICKED]: trackTravellersFieldResetClicked,
  [TRAVELLERS_FIELD_MULTIROOM_RESET_CLICKED]: trackTravellersFieldMultiroomResetClicked,
  [TRAVEL_PERIOD_FIELD_VALUE_CHANGED]: trackTravelPeriodFieldValueChanged,
  [FORM_SUBMITTED]: trackFormSubmitted,
  [RECENT_SEARCH_TRIGGERED]: recentSearchTriggered
};